export enum FileType {
    'lessonPdf',
}